import {publish} from '@/script/event.mjs'

export const savePublish = () => () => {
    return function () {
        return this.runAction(
            async () => {
                await this.actions.saveMap()
                await this.actions.publishUpgradeMap()
                publish(this, 'save')
            },

            {action: '保存&发布地图'},
        )
    }
}
